<template>
  <div class="collapse-field-detail">
    <b-collapse :open="false" position="is-bottom">
      <a slot="trigger" slot-scope="props">
        - {{  $t(label)}}
        <b-icon :icon="!props.open ? 'eye' : 'eye-off'"></b-icon>
      </a>
      <ul>
        <li v-for="value in values" :key="value">- {{$t(value)}}</li>
      </ul>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: ['label', 'values']
}
</script>

<style>
.collapse-field-detail .collapse-trigger > a {
  font-size: 20px;
  color: #363636;
  display: block;
  font-weight: 600;
}

.collapse-field-detail .collapse-content {
    z-index: 44;
    position: absolute;
    background: #df4e88;
    color: white;
    padding: 1rem;
}
.collapse-field-detail {
  margin-bottom: 1.75rem;
}
</style>